var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.72C0 .77.794 0 1.774 0h20.452C23.206 0 24 .77 24 1.72V22.28c0 .95-.794 1.719-1.774 1.719H1.774C.794 24 0 23.23 0 22.281V1.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.724 17.5V9.403H6.152V17.5h2.572ZM7.438 8.298c.897 0 1.456-.622 1.456-1.399C8.877 6.104 8.335 5.5 7.455 5.5S6 6.104 6 6.899c0 .777.558 1.399 1.422 1.399h.016Zm2.71 9.202h2.572v-4.521c0-.242.017-.484.085-.657.186-.484.609-.984 1.32-.984.93 0 1.303.742 1.303 1.83V17.5H18v-4.643c0-2.486-1.269-3.644-2.961-3.644-1.388 0-1.997.812-2.336 1.364h.017V9.403h-2.572c.034.76 0 8.097 0 8.097Z",
    fill: "var(--bg-color)"
  })));
};
export { SvgLinkedin as ReactComponent };
export default __webpack_public_path__ + "a1d4e1787dd17cd8cebfebe4afba52c8.svg";